import React from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import style from "../ViewLesson.module.css";
import styleActions from "./Actions.module.css";
import userStore from "../../../../base/stores/UserStore";
import deleteIcon from "../../../../base/assets/icons/delete-alt.svg";
import editIcon from "../../../../base/assets/icons/pencil_hover.svg";
import editHoverIcon from "../../../../base/assets/icons/edit_hover.png";
import store from "../../lessonStore";
import { LessonDI } from "../../types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom"; import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import lessonStore from "../../lessonStore";
import AppStore from "../../../../base/stores/AppStore";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: "15px",
    overflowY: "inherit",
  },
}));

const Actions = ({ lesson }: { lesson: LessonDI }) => {
  const [t] = useTranslation();
  const user = userStore?.user;
  const isEditor = user?.isEditor || false;
   const navigate = useNavigate(); 
  const [confirmOpen, setConfirmOpen] = React.useState(false);

  const handleClose = () => {
    setConfirmOpen(false);
  };

  const handleAgree = () => {
    setConfirmOpen(false);
    deleteLesson();
  };

  const deleteLesson = async () => {
    try {
      if (lesson?.id) {
        await store.deleteLesson(lesson?.id, AppStore.isMobileResolution);
        lessonStore.setLessonJustDeleted(true);
        navigate(AppStore.lessonsRoute);
      }
      // do nothing if "id" is missing
    } catch (error: any) {
      alert(t("GeneralError"));
    }
  };

  if ( lesson.isApproved) return null; // no actions should be rendered a at "approved" tab for "not editor"

  if (isEditor && lesson.isApproved && !AppStore.isMobileResolution)
    // delete button should be rendered at "approved" tab for "editor"
    return (
      <>
        <div className={styleActions.actions}>
          <Link
            aria-label={t("lesson-view-edit")}
            to={`${AppStore.lessonsRoute}${t("Lesson-edit-path")}/${lesson.url}`}
          >
            <img
              src={editIcon}
              alt={t("lesson-view-edit")}
              className={style.edit_icon}
            />
          </Link>
          <button
            className={styleActions.deleteButtonLink}
            onClick={() => setConfirmOpen(true)}
            aria-label={t("Lesson-delete")}
            tabIndex={0}
          >
            <img
              alt={t("Lesson-delete")}
              src={deleteIcon}
              className={style.edit_icon}
            />
            {t("Lesson-delete")}
          </button>
        </div>
        <BootstrapDialog
          open={confirmOpen}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{ "& .MuiPaper-root": { borderRadius: "22px" } }}
          >
          <div className={styleActions.bucketIcon} />
          <DialogTitle id="alert-dialog-title">
            <h2 className={styleActions.dialogTitle}>
              {t("Shall-Lesson-remove")}
            </h2>
          </DialogTitle>
          <DialogActions className={styleActions.dialogActions}>
            <Button
              className={styleActions.primary}
              onClick={handleAgree}
              autoFocus
            >
              {t("Lesson-delete-yes")}
            </Button>
            <Button onClick={handleClose} className={styleActions.secondary}>
              {t("Lesson-delete-no")}
            </Button>
          </DialogActions>
          <div className={styleActions.curve} />
        </BootstrapDialog>
      </>
    );

  if (!lesson.isApproved)
    // edit button should be rendered at "waiting-for-approve" tab for everyone
    return (
      <Link
        aria-label={t("lesson-view-edit")}
        to={`${AppStore.lessonsRoute}${t("Lesson-edit-path")}/${lesson.url}`}
      >
        <img
          src={editIcon}
          alt={t("lesson-view-edit")}
          className={style.edit_icon}
        />
        <img
          src={editHoverIcon}
          className={style.hoverEditIcon}
          alt={t("lesson-view-edit")}
        />
      </Link>
    );

  return null;
};

export default observer(Actions);
